// @flow

export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const BUY_TRANSACTION = 'BUY_TRANSACTION';

export const EDIT_TRANSACTION = 'EDIT_TRANSACTION';
export const REFAUND_TRANSACTION = 'REFAUND_TRANSACTION';

export const MODAL_CREDIT = 'MODAL_CREDIT';
export const MODAL_EDIT_CREDIT = 'MODAL_EDIT_CREDIT';

export const ADD_CREDIT = 'ADD_CREDIT';
export const SAVE_CREDIT = 'SAVE_CREDIT';
export const DELETE_CREDIT = 'DELETE_CREDIT';

export const ADD_OFFLINE = 'ADD_OFFLINE';

export const types = {
  credit: 'credit'
};
